// extracted by mini-css-extract-plugin
export default {"Hero":"Hero_Hero__PZgiZ","HowText":"Hero_HowText__2uMvI","SearchText":"Hero_SearchText__uyCd9","ButtonStart":"Hero_ButtonStart__cy++q"};